import { mat4, quat, vec3 } from 'gl-matrix';
/**
 * do RTS transformation for 2D/3D
 */

var Transform =
/** @class */
function () {
  function Transform() {
    this.dirtyFlag = false;
    this.localDirtyFlag = false;
    this.frozen = false;
    /**
     * local space RTS
     */

    this.localPosition = vec3.fromValues(0, 0, 0);
    this.localRotation = quat.fromValues(0, 0, 0, 1);
    this.localScale = vec3.fromValues(1, 1, 1);
    this.localTransform = mat4.create();
    /**
     * world space RTS
     */

    this.position = vec3.fromValues(0, 0, 0);
    this.rotation = quat.fromValues(0, 0, 0, 1);
    this.scaling = vec3.fromValues(1, 1, 1);
    this.worldTransform = mat4.create();
    /**
     * the origin of scaling and rotation
     */

    this.origin = vec3.fromValues(0, 0, 0); // /**
    //  * apply lerp to RTS, which can be used in camera animation
    //  *
    //  * @see https://xiaoiver.github.io/coding/2018/12/28/Camera-%E8%AE%BE%E8%AE%A1-%E4%B8%80.html
    //  */
    // lerp = (() => {
    //   const aS = vec3.create();
    //   const aR = quat.create();
    //   const aT = vec3.create();
    //   const bS = vec3.create();
    //   const bR = quat.create();
    //   const bT = vec3.create();
    //   return (a: Transform, b: Transform, t: number) => {
    //     this.setDirty();
    //     mat4.getScaling(aS, a.worldTransform);
    //     mat4.getTranslation(aT, a.worldTransform);
    //     mat4.getRotation(aR, a.worldTransform);
    //     mat4.getScaling(bS, b.worldTransform);
    //     mat4.getTranslation(bT, b.worldTransform);
    //     mat4.getRotation(bR, b.worldTransform);
    //     vec3.lerp(this.localScale, aS, bS, t);
    //     quat.slerp(this.localRotation, aR, bR, t);
    //     vec3.lerp(this.localPosition, aT, bT, t);
    //   };
    // })();
  }

  Transform.tag = 'c-transform';
  return Transform;
}();

export { Transform };